  import React, { useState } from 'react';
  import Header from './Header';
  import Footer from './Footer';
  import '../styles/Packaging.css';
  import OurProductsSection from "./OurProductsSection"

  import Packaging1 from '../assets/Packaging1.png'
  import Packaging2 from '../assets/Packaging2.png'
  import Packaging3 from '../assets/Packaging3.png'
  import Packaging4 from '../assets/Packaging4.png'
  import PackagingImg from '../assets/PackagingImg.jpg'

  import PackagingPdf from '../assets/dummy.pdf'
  // import QuoteModal from './QuoteModal'; // Adjust path
import WhatsAppModal from './WhatsAppModal';


  const Packaging = () => {
    // const [showModal, setShowModal] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);

    return (
      <div className="Packaging">
        <Header />

        {/* Hero Banner Section */}
        {/* <section className="hero-banner11">
          <div className="hero-content">
            <h1>Packaging</h1>
            <div className="breadcrumb">
              <span><a href="/" style={{ color: "#ACECFC" }}>Home</a></span> ⪢ <span>Packaging</span>
            </div>
          </div>
        </section> */}

<section className="Packaging-hero-clean">
  <div className="hero-text">
    <h1>Packaging</h1>
    <p>
      Our solutions address key pain points – from achieving precise quality control and optimizing high-speed production lines to ensuring flawless condition monitoring.
    </p>
  </div>
  <br/>
  <div className="hero-image">
    <img src={PackagingImg} alt="Packaging" />
  </div>
</section>

  <section className="packaging-content">
    {[
      {
        title: "Positioning of photomask in vacuum film forming device",
        text: "Realize flatness detection of photomask.",
        img: Packaging1
      },
      {
        title: "Correction of transparent film",
        text: "Using two ESQ series sensors to detect both sides of the transparent film, the high-sensitivity ESQ series sensors can identify the difference in the amount of light received.",
        img: Packaging2
      },
      {
        title: "Detect the positioning color mark on the packaging film",
        text: "ESC-18N/P has built-in three-color light source (RGB), which can automatically select the best light source R/G/B according to different colors.",
        img: Packaging3
      },
      {
        title: "Proximity sensor detection package",
        text: "When the scanning distance is short, the target is made of non-metallic materials, and the response time and positioning accuracy are not very important. The electrical Inductive sensors are a wise choice. The inductive proximity sensor detects the presence of the package.",
        img: Packaging4
      }

    ].map((item, idx) => (
      <div className={`packaging-row ${idx % 2 !== 0 ? 'reverse' : ''}`} key={idx}>
        <div className="packaging-image">
          <img src={item.img} alt={item.title} />
          <br/>
        </div>
        <div className="packaging-text">
          <h3>{item.title}</h3>
          <p>{item.text}</p>
          <br/>
        </div>
      </div>
    ))}
  </section>


  <OurProductsSection />
        <section className="action-buttons-section">
          <a href={PackagingPdf} target="_blank" rel="noopener noreferrer">
            <button className="download-btn">📄 Download</button>
          </a>
            <button className="quote-btn" onClick={() => setIsModalOpen(true)}>📩 Request a Quote</button>
            {/* <QuoteModal isOpen={showModal} onClose={() => setShowModal(false)} /> */}
      {/* WhatsApp Modal */}
      <WhatsAppModal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)} />

        </section>

        <Footer />
      </div>
    );
  };
  export default Packaging;